import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import instantChatIcon1 from "../../images/v4/linkGeneration/icons/instantChatIcon1.svg";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import darkGreenCheck from "../../images/v4/industry/education/icons/darkGreenCheck.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import transformBackgroundImage from "../../images/v4/linkGeneration/images/transformBackgroundImage.png";

import partnerSectionBackground from "../../images/v4/linkGeneration/images/partnerSectionBackground.png";

import bestPracticeIcon1 from "../../images/v4/industry/healthcare/icons/bestPracticeIcon1.svg";
import bestPracticeIcon2 from "../../images/v4/industry/healthcare/icons/bestPracticeIcon2.svg";
import bestPracticeIcon3 from "../../images/v4/industry/healthcare/icons/bestPracticeIcon3.svg";
import bestPracticeIcon4 from "../../images/v4/industry/healthcare/icons/bestPracticeIcon4.svg";
import bestPracticeIcon5 from "../../images/v4/industry/healthcare/icons/bestPracticeIcon5.svg";
import bestPracticeIcon6 from "../../images/v4/industry/healthcare/icons/bestPracticeIcon6.svg";

import gridIcon1 from "../../images/v4/industry/healthcare/icons/gridIcon1.svg";
import gridIcon2 from "../../images/v4/industry/healthcare/icons/gridIcon2.svg";
import gridIcon3 from "../../images/v4/industry/healthcare/icons/gridIcon3.svg";
import gridIcon4 from "../../images/v4/industry/healthcare/icons/gridIcon4.svg";
import gridIcon5 from "../../images/v4/industry/healthcare/icons/gridIcon5.svg";
import gridIcon6 from "../../images/v4/industry/healthcare/icons/gridIcon6.svg";
import gridIcon7 from "../../images/v4/industry/healthcare/icons/gridIcon7.svg";

import bestPracticeBg from "../../images/v4/industry/education/images/bestPracticeBg.png";
import industryHeroSectionBg from "../../images/v4/industry/education/images/industryHeroSectionBg.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/healthcare/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/healthcare/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/healthcare/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/industry/healthcare/images/compareItemImg5.png";

import featureSectionImg from "../../images/v4/industry/healthcare/images/featureSectionImg.png";
import meaningImg from "../../images/v4/industry/healthcare/images/meaningImg.png";
import benifitImg from "../../images/v4/industry/healthcare/images/benifitImg.png";
import bodySectionBg from "../../images/v4/industry/healthcare/images/bodySectionBg.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${industryHeroSectionBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "90px 0 220px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "0",
      paddingBottom: "300px",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(0deg, #5E02A8 5%, #009A99 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  pills: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    // marginTop: "25px",
  },
  pill: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "10px 16px",
    borderRadius: "30px",
    border: "1px solid #CEE9FF",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      padding: "10px 15px",
      "& img": {
        width: "20px",
      },
    },
  },
  experienceContainerHeader: {
    gap: "20px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "& h2": {
      width: "55%",
    },
    "& p": {
      width: "45%",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      "& h2": {
        width: "100%",
      },
      "& p": {
        width: "100%",
      },
    },
  },
  bodySection: {
    backgroundImage: `url(${bodySectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "top",
    paddingBottom: "300px",
    paddingTop: "260px",
    "& .container:first-child": {
      padding: "30px 0",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-460px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "500px",
      paddingBottom: "240px",
      "& .container:first-child": {
        padding: "30px 15px",
      },
    },
  },
  gridSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    rowGap: "24px",
    marginTop: "60px",
    "@media only screen and (max-width: 600px)": {
      marginTop: "40px",
    },
  },
  gridRow: {
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "24px",
    "&.row1": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "&.row2": {
      "& $gridCard": {
        width: "32%",
      },
    },
    "&.row3": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  gridCard: {
    display: "flex",
    flexDirection: "column",
    width: "48%",
    padding: "24px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    background: "#ffffff1a",
    borderRadius: "16px",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    gap: "16px",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100% !important",
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bestPracticeBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      paddingBottom: "170px",
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#fff",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "24px",
    width: "30%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(90deg, #011D32 0%, #00182B 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "75%",
    "@media only screen and (max-width: 600px)": {
      top: "91%",
    },
  },
  stripSection: {
    paddingTop: "280px",
    backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "180px",
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(0deg, #002C51 0%, #208EEC 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& $supportBox": {
        top: "-830px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  featureSection: {
    padding: "60px 0",
    background: "#F7F1FB",
  },
  featureSectionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "30px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  featureContainerLeft: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  featureContainerRight: {
    width: "50%",
    gap: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "& $cardPointer": {
      alignItems: "flex-start",
      "& img": {
        position: "relative",
        top: "5px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        position: "relative",
        top: "5px",
        width: "20px",
      },
    },
  },
  wpFaq: {
    // padding: "40px 0",
    "& $faqSection": {
      padding: 0,
    },
    background: "#F1FFF9",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  // testimonials: {
  //   paddingBottom: "40px",
  // },
}));

const HealthcareIndustry = () => {
  const classes = useStyles();
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question:
        "Can I import my existing healthcare patient data into the CRM?",
      answer: (
        <>
          Absolutely! You can import your existing patient data into the
          healthcare CRM. This usually involves uploading data files, such as
          CSV or Excel formats. Just ensure your data is clean, properly
          formatted, and compliant with data privacy regulations before the
          import process.
        </>
      ),
    },
    {
      question: "Do healthcare providers use CRM?",
      answer: (
        <>
          Yes, healthcare providers are increasingly adopting CRM systems to
          enhance various aspects of their operations. These systems improve
          patient care, streamline administrative tasks, and boost overall
          efficiency. A healthcare CRM facilitates better patient communication,
          appointment scheduling, data security, and analytics, leading to
          enhanced patient experiences and more effective care delivery.
        </>
      ),
    },
    {
      question: "What are the benefits of using healthcare CRM?",
      answer: (
        <>
          A healthcare CRM is essential for hospitals, clinics, and the broader
          healthcare industry to manage patient records and ensure optimal
          engagement. Key benefits include:
          <ul>
            <li>
              Improve Patient Care: Centralize patient information and history
              for better tracking, diagnosis, and treatment. No more sifting
              through piles of paperwork; just a click away from crucial patient
              reports!
            </li>
            <li>
              Increase Efficiency: Automate repetitive tasks such as sending
              follow-up reminders via WhatsApp or bulk messaging patients about
              free check-ups and promotions. With a CRM, these tasks are
              completed error-free and with minimal effort.
            </li>
            <li>
              Enhance Patient Experience: Leverage personalized and automated
              communication through WhatsApp and phone calls. Features like call
              recording and one-click dialing simplify patient interactions.
            </li>
            <li>
              Make Data-Driven Decisions: Gain insights into new and repeat
              patient numbers, prevalent conditions, and preferred doctors to
              inform your strategic decisions.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "What is the role of CRM in patient care management?",
      answer: (
        <>
          The role of CRM in patient care management encompasses:
          <ul>
            <li>
              Centralizing Patient Data: Ensures better access and management of
              patient information.
            </li>
            <li>
              Enhancing Patient Satisfaction: Facilitates timely and effective
              responses to patient inquiries via calls and WhatsApp.
            </li>
            <li>
              Automating Appointment Processes: Improves access to care and
              adherence to treatment plans.
            </li>
            <li>
              Personalizing Patient Care: Utilizes patient data to tailor care
              and communication effectively.
            </li>
            <li>
              Facilitating Continuous Engagement: Supports ongoing follow-ups,
              education, and preventive care initiatives.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "What makes Pepper Cloud CRM suitable for the healthcare industry?",
      answer: (
        <>
          Pepper Cloud CRM is tailored for healthcare with features like an
          approved secure system, patient journey tracking, appointment
          scheduling, automation, and integrated systems for CRM calling,
          invoicing and more, all designed to enhance patient care and
          streamline operations.
        </>
      ),
    },
    {
      question: "How does Pepper Cloud CRM help with patient engagement?",
      answer: (
        <>
          Pepper Cloud CRM offers features like automated appointment reminders,
          personalised communications, and chatbots to enhance engagement and
          improve patient satisfaction.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM suitable for small healthcare practices?",
      answer: (
        <>
          Yes, Pepper Cloud CRM is scalable and can be tailored to meet the
          needs of small practices, offering affordable pricing options and
          features designed for growing healthcare businesses.
        </>
      ),
    },
    {
      question: "Can Pepper Cloud CRM help with patient data analytics?",
      answer: (
        <>
          Pepper Cloud CRM provides advanced analytics tools to help healthcare
          providers gain insights into patient trends, treatment efficacy, and
          operational efficiency.
        </>
      ),
    },
  ];
  const features1 = [
    {
      icon: gridIcon1,
      alt: "",
      heading: "All-in-one solution",
      desc: "Pepper Cloud CRM integrates lead capture, patient management, appointment scheduling, and omnichannel support into one platform, streamlining operations.",
    },
    {
      icon: gridIcon2,
      alt: "",
      heading: "Lead management",
      desc: "Use in-built webforms and integrations like Facebook lead form to easily capture and manage patient inquiries, ensuring no leads are missed",
    },
  ];
  const features2 = [
    {
      icon: gridIcon3,
      alt: "",
      heading: "One-click WhatsApp",
      desc: "Engage patients instantly with one-click WhatsApp connections, making communication seamless and effective.",
    },
    {
      icon: gridIcon4,
      alt: "",
      heading: "Telecalling management",
      desc: "Streamline outreach and patient follow-ups with CRM telecalling features for enhanced efficiency.",
    },
    {
      icon: gridIcon5,
      alt: "",
      heading: "Follow-up reminder",
      desc: "Never miss an important follow-up again! Automated reminders help keep your team on track for patient engagements.",
    },
  ];
  const features3 = [
    {
      icon: gridIcon7,
      alt: "",
      heading: "Interaction tracking",
      desc: "Monitor and analyze every patient interaction to improve service quality and build lasting relationships.",
    },
    {
      icon: gridIcon6,
      alt: "",
      heading: "WhatsApp automation",
      desc: "Automate messages for appointments, reminders, and updates, enhancing patient interaction while saving time.",
    },
  ];
  const bestPractice = [
    {
      icon: bestPracticeIcon1,
      alt: "",
      heading: "Prioritise data security",
      desc: "Ensure healthcare CRM security and HIPAA compliance to protect sensitive patient information.",
    },
    {
      icon: bestPracticeIcon2,
      alt: "",
      heading: "Streamline data entry",
      desc: "Automate data capture in healthcare CRM to reduce errors and save time.",
    },
    {
      icon: bestPracticeIcon3,
      alt: "",
      heading: "Personalise patient interactions",
      desc: "Utilise healthcare CRM data for personalised patient care and communication.",
    },
    {
      icon: bestPracticeIcon4,
      alt: "",
      heading: "Integrate with existing systems",
      desc: "Ensure CRM integration with EHR, billing, and healthcare systems for a unified workflow.",
    },
    {
      icon: bestPracticeIcon5,
      alt: "",
      heading: "Train staff thoroughly",
      desc: "Provide CRM training to all users for maximum benefits and consistent usage.",
    },
    {
      icon: bestPracticeIcon6,
      alt: "",
      heading: "Regularly update patient information",
      desc: "Keep patient data updated for accurate and optimal care delivery.",
    },
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Athenahealth",
    "Kareo",
    "DrChrono",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM emerges as the top choice for healthcare providers seeking a comprehensive, user-friendly solution to streamline patient management and enhance overall care delivery. With its powerful features tailored specifically for the healthcare sector, Pepper Cloud CRM offers a perfect blend of functionality, ease of use, and scalability.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Patient management",
          desc: "Centralise patient data for a 360-degree view, ensuring personalised care and improved outcomes.",
        },
        {
          title: "Appointment scheduling",
          desc: "Automate appointment booking and reminders, reducing no-shows and enhancing patient engagement.",
        },
        {
          title: "AI-powered insights",
          desc: "Gain actionable insights through advanced analytics, helping you make data-driven decisions to improve patient care.",
        },
        {
          title: "Omnichannel support",
          desc: "Integrate with various communication platforms, including WhatsApp, for efficient patient interactions.",
        },
        {
          title: "Customisable workflows",
          desc: "Adapt the CRM to your specific healthcare speciality and operational requirements.",
        },
        {
          title: "Mobile accessibility",
          desc: "Access patient information and manage your practice on-the-go with iOS and Android mobile apps.",
        },
      ],
    },
    {
      title: "Salesforce Health Cloud",
      desc: "Salesforce Health Cloud is a robust CRM solution designed for healthcare organisations, offering patient relationship management and care coordination features. It provides a holistic view of patient data and enables personalised patient engagement.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Patient 360",
          desc: "Comprehensive view of patient health records and interactions.",
        },
        {
          title: "Care coordination",
          desc: "Collaborate across care teams for better patient outcomes.",
        },
        {
          title: "Patient engagement tools",
          desc: "Personalised communication and education resources.",
        },
        {
          title: "Analytics and reporting",
          desc: "Data-driven insights for informed decision-making.",
        },
      ],
    },
    {
      title: "Athenahealth",
      desc: " Athenahealth offers a cloud-based EHR and practice management solution with integrated CRM capabilities. It focuses on improving clinical efficiency and patient engagement for healthcare providers.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Practice management",
          desc: "Streamline administrative tasks and billing processes.",
        },
        {
          title: "Patient portal",
          desc: "Secure platform for patients to access health information and communicate with providers.",
        },
        {
          title: "Population health management",
          desc: "Tools for managing patient populations and improving outcomes.",
        },
        {
          title: "Telehealth integration",
          desc: "Seamless virtual care capabilities within the platform.",
        },
      ],
    },
    {
      title: "Kareo",
      desc: "Kareo is a comprehensive healthcare technology platform that combines practice management, EHR, and patient engagement tools. It's particularly suited for independent practices and small to medium-sized healthcare organisations.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Billing and claims management",
          desc: "Integrated tools for efficient revenue cycle management.",
        },
        {
          title: "Patient scheduling",
          desc: "User-friendly appointment booking and management system.",
        },
        {
          title: "Marketing tools",
          desc: "Features to help practices attract and retain patients.",
        },
        {
          title: "Telehealth solutions",
          desc: "Built-in virtual care capabilities for remote patient consultations.",
        },
      ],
    },
    {
      title: "DrChrono",
      desc: "DrChrono offers an all-in-one EHR, practice management, and medical billing platform with CRM functionalities. It's known for its iPad-native EHR system and customisable features.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Mobile EHR",
          desc: "Fully functional EHR system optimised for iPad use.",
        },
        {
          title: "Custom medical forms",
          desc: "Ability to create tailored forms and workflows.",
        },
        {
          title: "Patient check-in kiosk",
          desc: "Streamlined digital check-in process for patients.",
        },
        {
          title: "RCM services",
          desc: "Integrated revenue cycle management solutions.",
        },
      ],
    },
  ];
  const industryFeature = [
    {
      title: "Assess your specific needs",
      desc: "Identify challenges and goals to ensure the healthcare CRM fits your needs.",
    },
    {
      title: "Consider integration capabilities",
      desc: "Select a healthcare CRM that integrates with EHR and billing systems for smooth operations.",
    },
    {
      title: "User-friendliness",
      desc: "Choose an intuitive healthcare CRM for easy staff adoption and minimal learning.",
    },
    {
      title: "Scalability",
      desc: "Choose a scalable healthcare CRM to accommodate growing patient volumes and services.",
    },
    {
      title: "Mobile accessibility",
      desc: "Choose a mobile-friendly healthcare CRM for on-the-go patient and practice management.",
    },
  ];
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <main>
      <SEO
        title={"Best CRM for Healthcare Industry | Pepper Cloud"}
        pathname={
          "https://peppercloud.com/industry/best-crm-for-healthcare-business/"
        }
        keywords="best crm software for healthcare industry,health care crm, crm software for healthcare industry, advantages of crm in health sector, crm for healthcare marketing, healthcare crm software, crm in healthcare industry, crm for healthcare, best crm for healthcare, best crm software for healthcare industry, crm software for healthcare"
        description={
          "Best CRM for hospitals, clinics and the healthcare industry to maintain patient records, tagging and segmenting patients and ensure optimum engagement effectively."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Can I import my existing healthcare patient data into the CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely! You can import your existing patient data into the healthcare CRM. This usually involves uploading data files, such as CSV or Excel formats. Just ensure your data is clean, properly formatted, and compliant with data privacy regulations before the import process.",
                },
              },
              {
                "@type": "Question",
                name: "Do healthcare providers use CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, healthcare providers are increasingly adopting CRM systems to enhance various aspects of their operations. These systems improve patient care, streamline administrative tasks, and boost overall efficiency. A healthcare CRM facilitates better patient communication, appointment scheduling, data security, and analytics, leading to enhanced patient experiences and more effective care delivery.",
                },
              },
              {
                "@type": "Question",
                name: "What are the benefits of using healthcare CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A healthcare CRM is essential for hospitals, clinics, and the broader healthcare industry to manage patient records and ensure optimal engagement. Key benefits include: Improve Patient Care: Centralize patient information and history for better tracking, diagnosis, and treatment. No more sifting through piles of paperwork; just a click away from crucial patient reports! Increase Efficiency: Automate repetitive tasks such as sending follow-up reminders via WhatsApp or bulk messaging patients about free check-ups and promotions. With a CRM, these tasks are completed error-free and with minimal effort. Enhance Patient Experience: Leverage personalized and automated communication through WhatsApp and phone calls. Features like call recording and one-click dialing simplify patient interactions. Make Data-Driven Decisions: Gain insights into new and repeat patient numbers, prevalent conditions, and preferred doctors to inform your strategic decisions.",
                },
              },
              {
                "@type": "Question",
                name: "What is the role of CRM in patient care management?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The role of CRM in patient care management encompasses: Centralizing Patient Data: Ensures better access and management of patient information. Enhancing Patient Satisfaction: Facilitates timely and effective responses to patient inquiries via calls and WhatsApp. Automating Appointment Processes: Improves access to care and adherence to treatment plans. Personalizing Patient Care: Utilizes patient data to tailor care and communication effectively. Facilitating Continuous Engagement: Supports ongoing follow-ups, education, and preventive care initiatives.",
                },
              },
              {
                "@type": "Question",
                name: "What makes Pepper Cloud CRM suitable for the healthcare industry?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is tailored for healthcare with features like an approved secure system, patient journey tracking, appointment scheduling, automation, and integrated systems for CRM calling, invoicing and more, all designed to enhance patient care and streamline operations.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud CRM help with patient engagement?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM offers features like automated appointment reminders, personalised communications, and chatbots to enhance engagement and improve patient satisfaction.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM suitable for small healthcare practices?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM is scalable and can be tailored to meet the needs of small practices, offering affordable pricing options and features designed for growing healthcare businesses.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud CRM help with patient data analytics?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM provides advanced analytics tools to help healthcare providers gain insights into patient trends, treatment efficacy, and operational efficiency.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-18"
              style={{ color: "#0291AE" }}
            >
              Healthcare
            </motion.h1>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Best CRM for healthcare marketing
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Pepper Cloud CRM empowers healthcare providers to deliver
              exceptional patient experiences while streamlining operations and
              boosting efficiency across the board.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Centralise patient data
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Connect with patients
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Automate appointments and follow-ups
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link className="primaryButton font-20 font-wix-medium font-white">
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.bodySection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What is a healthcare CRM?
              </p>
              <p
                className="font-18 font-inter-regular"
                style={{ color: "#BEE7E7" }}
              >
                A healthcare CRM is a specialised tool for managing patient
                relationships and improving care delivery. It streamlines
                operations while ensuring patient privacy and regulatory
                compliance. Tailored to the medical sector, it simplifies
                complex care coordination.
              </p>
              <div className={classes.pills}>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    AI-powered
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    WhatsApp capabilities
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    Easy to use
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    24/7 Local support
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    No hidden charges
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={meaningImg}
                alt={"Benefits of WhatsApp link generator"}
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className={classes.experienceContainerHeader}>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Why Pepper Cloud is the best CRM for healthcare industry
            </motion.h2>
          </div>
          <div className={classes.gridSection}>
            <div className={clsx(classes.gridRow, "row1")}>
              {features1.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.alt} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row2")}>
              {features2.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.alt} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row3")}>
              {features3.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.alt} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What are the benefits of using CRM in the health sector?
              </p>
              <div className={classes.pointers}>
                {[
                  "Enhanced patient care: Centralise patient data for a comprehensive view, enabling personalised care and improved outcomes.",
                  "Streamlined operations: Automate tasks like scheduling, reminders, and follow-ups, allowing staff to focus on patient care.",
                  "Improved communication: Facilitate seamless communication between healthcare providers, patients, and staff, keeping everyone engaged.",
                  "Data-driven decision making: Utilise advanced analytics to gain insights into patient trends, treatment efficacy, and operational efficiency for strategic decisions.",
                ].map((benefit, index) => (
                  <div key={index} className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {benefit}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benifitImg}
                alt={"What are the benefits of using CRM in the health sector?"}
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 Best CRM for healthcare industry in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.featureSection}>
        <div className="container">
          <div className={classes.featureSectionContainer}>
            <div className={classes.featureContainerLeft}>
              <LazyImage source={featureSectionImg} width={"100%"} alt={""} />
            </div>
            <div className={classes.featureContainerRight}>
              <p className="font-wix-medium font-40 color-black1">
                How to choose the best CRM for healthcare industry
              </p>
              <div className={classes.pointers}>
                {industryFeature.map((point) => (
                  <div className={classes.cardPointer}>
                    <LazyImage source={darkGreenCheck} alt={"pointer"} />
                    <p className="font-18 font-inter-regular color-black1">
                      {point.title}: {point.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Healthcare CRM software: Best practices
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.alt} />
                <p className="font-wix-semibold font-24 font-black1">
                  {practice.heading}
                </p>
                <p className="font-wix-medium font-16 font-black1">
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>
      </section>
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#F1FFF9"}
          heading={"FAQs - best CRM for healthcare industry"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Smart CRM for smart care: Connect, manage, and elevate!
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HealthcareIndustry;
